/* eslint-disable no-param-reassign, no-shadow, no-console */
import Config from '@/config'
import { allSlideTypes } from '@/constant/slideTypes'

const state = () => ({
  slideTypes: [],
  isLoading: false,
  error: null,
  fetchPromise: null,
})

const getters = {
  marketplaceSlideTypes: (state) => state.slideTypes,
  isMarketplaceLoading: (state) => state.isLoading,
  marketplaceError: (state) => state.error,
}

const mutations = {
  FETCH_SLIDE_TYPES_START(state, promise) {
    state.isLoading = true
    state.error = null
    state.fetchPromise = promise
  },
  FETCH_SLIDE_TYPES_SUCCESS(state, slideTypes) {
    state.isLoading = false
    state.slideTypes = slideTypes
    state.fetchPromise = null
  },
  FETCH_SLIDE_TYPES_FAILURE(state, error) {
    state.isLoading = false
    state.error = error
    state.fetchPromise = null
  },
}

const actions = {
  async fetchMarketplaceSlideTypes({
    commit,
    state,
    rootState,
    rootGetters,
  }) {
    if (!rootGetters['featureToggles/canUseNewSlideMarketPlace']) return Promise.resolve()

    const mapSlidesTypeObj = () => {
      const { presentation } = rootState
      if (presentation && presentation.slides) {
        presentation.slides.forEach((slide) => {
          if (slide.type && (!slide.typeObj || Object.keys(slide.typeObj).length === 0)) {
            let foundType = allSlideTypes.find((s) => s.type === slide.type)
            if (!foundType && rootGetters['featureToggles/canUseNewSlideMarketPlace']) {
              const marketplaceSlide = state.slideTypes.find((s) => s.type === slide.type)
              if (marketplaceSlide) {
                foundType = { ...marketplaceSlide, source: 'fromMarket', plugin: true }
              }
            }
            if (foundType) {
              slide.typeObj = foundType
            }
          }
        })
      }

      const { slideActive } = rootState
      if (slideActive && slideActive.type && (!slideActive.typeObj || Object.keys(slideActive.typeObj).length === 0)) {
        let foundType = allSlideTypes.find((s) => s.type === slideActive.type)
        if (!foundType && rootGetters['featureToggles/canUseNewSlideMarketPlace']) {
          const marketplaceSlide = state.slideTypes.find((s) => s.type === slideActive.type)
          if (marketplaceSlide) {
            foundType = { ...marketplaceSlide, source: 'fromMarket', plugin: true }
          }
        }
        if (foundType) {
          slideActive.typeObj = foundType
        }
      }
    }

    if (state.slideTypes.length > 0) {
      mapSlidesTypeObj()
      return Promise.resolve()
    }
    if (state.fetchPromise) {
      return state.fetchPromise.then(() => {
        mapSlidesTypeObj()
        return true
      })
    }

    const promise = (async () => {
      try {
        const response = await fetch(`${Config.ahaslideMarketplaceUrl}api/slide-types`)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        const rawTypes = Array.isArray(data) ? data : (data.slideTypes || [])
        const fetchedTypes = rawTypes.map((slide) => ({
          ...slide,
          type: slide.type.replace('marketplace/', ''),
        }))

        // Backfill typeObj on slides in the current presentation
        mapSlidesTypeObj()

        commit('FETCH_SLIDE_TYPES_SUCCESS', fetchedTypes)
      } catch (e) {
        console.error('Failed to fetch marketplace slide types:', e)
        commit('FETCH_SLIDE_TYPES_FAILURE', e.message || 'Unknown error')
      }
    })()

    commit('FETCH_SLIDE_TYPES_START', promise)

    return promise
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
